module.exports = __webpack_public_path__ + "img/dp-sy-zt2.bc8b4c0a.png";